// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lds1Y","title":"styles_title__LokMQ","description":"styles_description__nDUe0","buttons":"styles_buttons__r-Hc+"};